import React from "react";
import { ContainerBrinde } from "./styles";
import { Input } from "../../Input";
import { useTheme } from "../../../contexts/Theme/ThemeContext";
import { currencyMask } from "../../../services/Masks";
import { unmaskToNumbers } from "../../../services/Unmasks";
import { Toggle } from "../../Toggle/Toggle";
import ImageUploadCategoria from "../../Upload/ImageUploadCategoria/ImageUploadCategoria";
import { Brinde as BrindeType } from "../../../types/Brinde";
import moment from "moment";

interface BrindeProps {
  setBrinde: (brinde: BrindeType) => void;
  brinde: BrindeType;
}

const Brinde: React.FC<BrindeProps> = ({ setBrinde, brinde }) => {
  const { theme } = useTheme();

  const imagemPreview = brinde.imagem_base64
    ? brinde.imagem_base64
    : brinde.foto
    ? brinde.foto.replace("{size}", "413")
    : "";

  const isValor = brinde.tipo_regra !== "quantidade";

  return (
    <ContainerBrinde theme={theme}>
      <div className="containerBrinde">
        <div className="inputContainer">
          {/* Foto + Nome */}
          <div className="row1">
            <div className="foto">
              <ImageUploadCategoria
                value={imagemPreview}
                onChange={(base64, imagem) => {
                  setBrinde({ ...brinde, imagem_base64: base64, imagem_nome: imagem });
                }}
              />
            </div>
            <div className="campo-nome">
              <Input
                type="text"
                value={brinde.nome}
                placeholder="Nome do Brinde"
                required={true}
                maxLength={64}
                showMaxLength={false}
                onChange={(newValue) => setBrinde({ ...brinde, nome: newValue })}
                label="Nome do Brinde"
              />
            </div>
          </div>

          {/* Estoque + Peso */}
          <div className="row2">
            <Input
              type="number"
              value={brinde.estoque?.toString() ?? "0"}
              placeholder="0"
              required={true}
              onChange={(newValue) => setBrinde({ ...brinde, estoque: newValue === "" ? 0 : parseInt(newValue) })}
              label="Estoque"
            />
            <Input
              type="number"
              value={brinde.peso?.toString() ?? "0"}
              placeholder="0"
              required={false}
              onChange={(newValue) =>
                setBrinde({ ...brinde, peso: newValue === "" ? 0 : parseFloat(newValue.replace(",", ".")) })
              }
              label="Peso (g)"
            />
          </div>

          {/* Regra: quando o cliente ganha o brinde */}
          <div className="regra">
            <span className="regraTitulo fonteTexto">Quando o cliente ganha o brinde?</span>
            <div className="regraRadios">
              <label>
                <Input
                  type="radio"
                  name="tipoRegra"
                  value="valor"
                  checked={isValor}
                  onChange={() =>
                    setBrinde({ ...brinde, tipo_regra: "valor", valor_minimo: null, quantidade_minima: null })
                  }
                  placeholder="Ao atingir valor mínimo de sacola"
                  label="Ao atingir valor mínimo de sacola"
                />
              </label>
              {isValor && (
                <div className="flex-valorMin">
                  <Input
                    type="text"
                    mask={{ mask: currencyMask, unmask: unmaskToNumbers }}
                    value={brinde.valor_minimo && brinde.valor_minimo > 0 ? brinde.valor_minimo.toString() : "0"}
                    placeholder="R$100,00"
                    required={true}
                    onChange={(newValue) => setBrinde({ ...brinde, valor_minimo: parseFloat(newValue) })}
                  />
                </div>
              )}

              <label>
                <Input
                  type="radio"
                  name="tipoRegra"
                  value="quantidade"
                  checked={!isValor}
                  onChange={() =>
                    setBrinde({ ...brinde, tipo_regra: "quantidade", valor_minimo: null, quantidade_minima: null })
                  }
                  placeholder="Ao adicionar uma quantidade mínima de produtos"
                  label="Ao adicionar uma quantidade mínima de produtos"
                />
              </label>
              {!isValor && (
                <div className="flex-valorMin">
                  <Input
                    type="number"
                    value={brinde.quantidade_minima?.toString() ?? ""}
                    placeholder="00"
                    required={true}
                    onChange={(newValue) =>
                      setBrinde({ ...brinde, quantidade_minima: newValue === "" ? null : parseInt(newValue) })
                    }
                  />
                </div>
              )}
            </div>
          </div>

          {/* Expiração */}
          <div className="agendarExpiracao fonteTexto">
            <label>
              <Toggle
                value={brinde.data_expiracao !== undefined && brinde.data_expiracao !== null}
                onChange={(newValue) =>
                  setBrinde({ ...brinde, data_expiracao: newValue ? new Date().toISOString() : null })
                }
              />
              Agendar data de expiração
            </label>
            <div className={`flex expiracao ${brinde.data_expiracao ? "ativo" : ""}`}>
              {brinde.data_expiracao && (
                <Input
                  type="datetime-local"
                  value={moment(brinde.data_expiracao).format("YYYY-MM-DDTHH:mm")}
                  placeholder="2023-04-27 11:28:00"
                  onChange={(newValue) =>
                    setBrinde({
                      ...brinde,
                      data_expiracao: moment(newValue, "YYYY-MM-DDTHH:mm:ss").format("YYYY-MM-DD HH:mm"),
                    })
                  }
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </ContainerBrinde>
  );
};

export default Brinde;
